import {
  MEMBERSHIP_TAX_CODE,
  MEMBERSHIP_CHICAGO_LEASE_TAX_CODE
} from '@/const/stripe';

type TaxAddress = {
  city?: string | null;
  state?: string | null;
};

/**
 * Chicago charges a 15% Personal Property Lease Transaction Tax on memberships
 * used in the city. Detection is a heuristic on the entered city/state — it
 * covers both the Cook and DuPage portions of the City of Chicago (both use the
 * city name "Chicago") while excluding suburbs like Chicago Heights. Stripe's own
 * geocoding is the authority for the actual charge, so the downstream subscription
 * must apply the same rule when it selects the membership product/tax code.
 */
export const isChicagoLeaseTaxAddress = (address: TaxAddress): boolean => {
  const city = address.city?.trim().toLowerCase();
  const state = address.state?.trim().toUpperCase();
  return city === 'chicago' && state === 'IL';
};

/**
 * The Stripe product tax code to apply for a membership shipped to `address`.
 * Chicago addresses get the lease-classed code (so Stripe returns the 15% lease
 * tax and exempts sales tax); everywhere else keeps the default tangible-goods
 * code, unchanged from today.
 */
export const getMembershipTaxCode = (address: TaxAddress): string =>
  isChicagoLeaseTaxAddress(address)
    ? MEMBERSHIP_CHICAGO_LEASE_TAX_CODE
    : MEMBERSHIP_TAX_CODE;
